import { cn } from '@/lib/utils';

/** Indeterminate loading bar — blue primary track + fill. */
export const brandLoadingBarTrackClass = (withTransition = false) =>
  cn(
    'relative h-0.5 w-full overflow-hidden bg-primary/15',
    withTransition && 'transition-opacity duration-200',
  );

export const brandLoadingBarFillClass =
  'absolute inset-y-0 left-0 w-full bg-gradient-to-r from-primary/60 via-primary to-primary animate-indeterminate-progress';

interface TopLoadingBarProps {
  active: boolean;
  className?: string;
}

/**
 * Indeterminate top loading bar (YouTube/GitHub style).
 * Renders a thin animated bar; collapses to nothing when inactive.
 */
export function TopLoadingBar({ active, className }: TopLoadingBarProps) {
  if (!active) return null;
  return (
    <div
      role="progressbar"
      aria-busy="true"
      aria-label="Loading"
      className={cn(brandLoadingBarTrackClass(), className)}
    >
      <div className={brandLoadingBarFillClass} />
    </div>
  );
}
